import buttonToCSS from "./buttons";
import labelToCSS from "./labels";
import viewToCSS from "./views";

export default {
  buttonToCSS,
  labelToCSS,
  viewToCSS,
};
